import SampleReportView from "@/components/samples/SampleReportView";
import { SUNVEST_REPORT } from "@/data/sample-reports";

const SunVestSample = () => <SampleReportView report={SUNVEST_REPORT} />;

export default SunVestSample;
